"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GlassCard = GlassCard;
var jsx_runtime_1 = require("react/jsx-runtime");
var material_1 = require("@mui/material");
var theme_1 = require("../../theme");
var tokens_1 = require("../../tokens");
function GlassCard(_a) {
    var children = _a.children, _b = _a.accentBar, accentBar = _b === void 0 ? false : _b, accentColor = _a.accentColor, _c = _a.cornerRadius, cornerRadius = _c === void 0 ? tokens_1.radius.md : _c, _d = _a.glass, glass = _d === void 0 ? true : _d, _e = _a.bordered, bordered = _e === void 0 ? true : _e, _f = _a.highlight, highlight = _f === void 0 ? false : _f, sx = _a.sx, rest = __rest(_a, ["children", "accentBar", "accentColor", "cornerRadius", "glass", "bordered", "highlight", "sx"]);
    var p = (0, theme_1.useV2Palette)();
    return ((0, jsx_runtime_1.jsxs)(material_1.Box, __assign({}, rest, { sx: __spreadArray([
            __assign({ position: 'relative', borderRadius: "".concat(cornerRadius, "px"), backgroundColor: glass ? p.background.sub : p.background.surface, backdropFilter: glass ? "blur(".concat(tokens_1.blur.card, "px)") : undefined, 
                // iOS/WKWebView (Capacitor) では -webkit- が無いと backdrop-filter が効かない
                WebkitBackdropFilter: glass ? "blur(".concat(tokens_1.blur.card, "px)") : undefined, 
                // highlight=trueの時は下の::afterが上端のinsetハイライトを別途
                // 描画するため、ここではドロップシャドウのみにしてinsetの二重描画を避ける
                boxShadow: glass
                    ? highlight
                        ? p.shadow.cardDrop
                        : p.shadow.cardGlass
                    : 'none', border: bordered ? "1px solid ".concat(p.border.neutral.default) : 'none', overflow: 'hidden' }, (highlight && {
                '&::after': {
                    content: '""',
                    position: 'absolute',
                    inset: 0,
                    borderRadius: 'inherit',
                    boxShadow: p.shadow.cardHighlight,
                    pointerEvents: 'none',
                },
            }))
        ], (Array.isArray(sx) ? sx : [sx]), true), children: [accentBar && ((0, jsx_runtime_1.jsx)(material_1.Box, { sx: {
                    position: 'absolute',
                    left: 0,
                    top: 0,
                    bottom: 0,
                    width: 4,
                    borderRadius: "".concat(tokens_1.radius.lg, "px"),
                    backgroundColor: accentColor !== null && accentColor !== void 0 ? accentColor : p.foreground.primary.main,
                } })), children] })));
}
